import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { store } from '../../store';
import { buscarDados } from '../../store/modules/parceiro/actions';
import { useSiteBloqueado } from '../../hooks/useSiteBloqueado';
import SiteBloqueado from '../../components/Loja/SiteBloqueado';

export default function RotaLoja({
  component: Component,
  rotaPrivada = false,
  ...atributos
}) {
  const { autenticadoLoja } = store.getState().autenticacao;
  const { isBloqueado, loading } = useSiteBloqueado();

  autenticadoLoja && store.dispatch(buscarDados());

  if (!loading && isBloqueado) {
    return <Route {...atributos} component={SiteBloqueado} />;
  }

  if (!autenticadoLoja && rotaPrivada) {
    return <Redirect to="/" />;
  }

  if (autenticadoLoja && !rotaPrivada && atributos.path === '/') {
    return <Redirect to="/home" />;
  }

  return <Route {...atributos} component={Component} />;
}
